module.exports = __webpack_public_path__ + "static/media/icon-sort.e2ebd9cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/search/sort-select/icon-sort.svg
// module id = 1074
// module chunks = 1